const menuToggleButton = document.querySelector('.menu-toggle-button');
const mainNav = document.querySelector('.main-nav');
const widgetVisible = document.querySelector('.widget-visible');

if (menuToggleButton) {
    menuToggleButton.addEventListener('click', function (event) {
        event.preventDefault();

        mainNav.classList.toggle('menu-open');

        // Note: fix the "Message" button overlap with mobile menu issue in mobile view
        //       (this "Message" button can not be seen in the local environment!)
        if(widgetVisible) {
            if(mainNav.classList.contains('menu-open')) {
                widgetVisible.setAttribute('style', 'display:none !important');
            } else {
                widgetVisible.setAttribute('style', 'display:block !important');
            }
        } else {
            return;
        }
    });
}